import * as React from 'react'
import { useReducer, useState } from 'react'
import GridContainer from '../grid/GridContainer'
import GridItem from '../grid/GridItem'
import CustomInput from '../input/CustomInput'
import Button from '../button/RegularButton'
import { timeout } from '../../App'
import Snackbar from '../snackbar/Snackbar'
import { AddAlert } from '@material-ui/icons'
import { initialNotificationState } from '../utils/state/ApplicationState'
import { getApiUrl } from '../../api/api'

function stateReducer(state, action) {
  switch (action.type) {
    case 'field':
      return {
        ...state,
        [action.field]: action.value,
      }
    case 'success':
      return {
        ...initialState,
        success: true,
      }
    case 'error':
      return {
        success: false,
        errorMessage: action.errorMessage,
      }

    default:
      break
  }
  return state
}

const initialState = {
  success: false,
  errorMessage: '',
  subject: '',
  content: '',
  test: false,
}

export default function InfoEmailDistributor() {
  const [state, dispatch] = useReducer(stateReducer, initialState)

  const [notification, setNotification] = useState(initialNotificationState)

  function defineTestEmail(obj, isTest) {
    let objCopy = JSON.parse(JSON.stringify(obj))
    objCopy.test = isTest
    return objCopy
  }

  const submitForm = (e, isTest) => {
    e.preventDefault()

    getApiUrl()
      .post(`/api/email`, defineTestEmail(state, isTest))
      .then(function() {
        dispatch({ type: 'success' })
        setNotification({
          open: true,
          message: 'Erfolgreich versandt',
          color: 'success',
        })
      })
      .catch(function(error) {
        dispatch({ type: 'error', errorMessage: error })
        setNotification({
          open: true,
          message: error.response.data.message,
          color: 'danger',
        })
      })
      .finally(
        setTimeout(function() {
          setNotification(initialNotificationState)
        }, timeout),
      )
  }

  return (
    <GridContainer>
      <GridItem xs={12} sm={12} md={12}>
        <GridContainer>
          <GridItem xs={12} sm={12} md={4}>
            <CustomInput
              labelText="Betreff"
              id="subject"
              formControlProps={{
                fullWidth: true,
              }}
              inputProps={{
                value: state.subject,
                type: 'text',
                onChange: (e) =>
                  dispatch({
                    type: 'field',
                    field: 'subject',
                    value: e.currentTarget.value,
                  }),
              }}
            />
          </GridItem>
        </GridContainer>
        <GridContainer>
          <GridItem xs={12} sm={12} md={10}>
            <CustomInput
              labelText="Email Inhalt"
              id="content"
              formControlProps={{
                fullWidth: true,
              }}
              inputProps={{
                value: state.content,
                type: 'text',
                multiline: true,
                rows: 40,
                onChange: (e) =>
                  dispatch({
                    type: 'field',
                    field: 'content',
                    value: e.currentTarget.value,
                  }),
              }}
            />
          </GridItem>
        </GridContainer>
        <br/>
        <GridContainer>
          <GridItem xs={12} sm={12} md={4}>
            <Button
              color="primary"
              onClick={(e) => {
                submitForm(e, false)
              }}>
              Aktuelle Bewohner informieren
            </Button>
          </GridItem>
          <GridItem xs={12} sm={12} md={4}>
            <Button
              color="primary"
              onClick={(e) => {
                submitForm(e, true)
              }}>
              Test E-Mail senden
            </Button>
          </GridItem>
        </GridContainer>
        <Snackbar
          place="br"
          color={notification.color}
          icon={AddAlert}
          message={notification.message}
          open={notification.open}
          closeNotification={() =>
            setNotification({
              open: false,
              message: '',
              color: '',
            })
          }
          close
        />
      </GridItem>
    </GridContainer>
  )
}
